import React, { useState, useEffect } from 'react';
import { DeletePaymentLink, PaymentLink } from '../../pages';
import { amountFormatter } from '../../utils/utils';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import * as yup from 'yup';
import { object, string, number, array, boolean, date } from 'yup';
import { PaymentLinkController } from '../../controllers';
import { paymentLinkStore } from '../../stores';

const DeletePaymentLinkContainer = ({closeModal}) => {
  const [loading, setLoading] = useState(false);

  const selectedLink = paymentLinkStore.selectedPaymentLink

  const confirmDelete = async() => {
    setLoading(true);
    const id = selectedLink._id
    const { status, errorMessage } = await PaymentLinkController.deletePaymentLink(id);

      if (status === constant.Success) {
        MimaToastUtil.success({
          message: constant.Success,
        });
        setLoading(false);
        closeModal();
      } else {
        setLoading(false);
        MimaToastUtil.error({ message: errorMessage });
      }
    }

  return (
    <DeletePaymentLink
      closeModal={closeModal}
      selectedLink={selectedLink}
      loading={loading}
      confirmDelete={confirmDelete}
    />
  )
}

export default DeletePaymentLinkContainer